<template>
    <div class="content">
        <p class="description">精读圣经是一款功能强大，资源丰富，可完全离线使用的圣经工具。<br>电脑版有专门的投影模块，投影非常赞！除此之外还含有模块制作功能，可用于制作译本、注释、灵修、辞典及读经计划。制作的资料可以上传服务器，以「口令」的形式提供下载，也可以使用「数据传输」功能分发到其他设备。</p>
        <div class="os">
            <h2><span class="icon iconfont">&#xe680;&#xe681;&#xe683;</span>Android</h2>
            <p class="info">华为、荣耀、OPPO、VIVO、小米等品牌。</p>
            <p>鸿蒙5需要通过卓易通安装此版本，使用卓易通中的浏览器（如搜应用）打开此网站，下载此安装包，回到卓易通，点我的->文件共享->文件，可以看到下载的apk文件，点文件安装。</p>
            <p><span style='color: #ff0000'>若出现系统阻止安装，请在下载好安装包后断开无线网络及数据流量后再安装。</span></p>
            <p><span style='color: #46B8DA'>有VIVO手机的弟兄姊妹反馈打开App会弹出广告，这可能与快应用有关。有热心姊妹提供解决方法，可以试试：</span><br>
            <span style='color: #4CAE4C'>打开系统设置->应用与权限->系统应用设置->快应用->快应用管理->快应用跳转管理->App内跳转快应用 *这一项关掉* <a href="qa3.htm" role="button">查看截图</a></span></p>
            <a-space>
                <a-button id="button" type="primary" @click="openHref('flutter bible apk', flutter_bibleApkUrl)">测试版v{{flutter_bibleApkVersion}} 下载</a-button>
                <a-button id="button" type="primary" @click="openHref('bible apk', bibleApkUrl)">v{{bibleApkVersion}} 下载</a-button>					
            </a-space>						
        </div>	
        <div class='divider'></div>
        <div class="os">
            <h2><span class="icon iconfont">&#xe6bb;</span>HarmonyOS NEXT</h2>
            <p>华为新系统，2024.11开始陆续推送正式版。需要下载侧载工具，建议首次在卓易通中安装Android版的侧载工具。然后使用卓易通中的浏览器（如搜应用）下载的精读、诗歌的鸿蒙版安装包，才能在侧载工具中被选择；鸿蒙版侧载工具需要使用鸿蒙版浏览器下载安装包。（侧载工具非本站制作）</p>
            <p style="color: red;">开发者账号需要<a href="https://developer.huawei.com/consumer/cn/doc/start/itrna-0000001076878172">实名认证</a>，认证后安装可使用6个月，过期后重新安装，不认证只能使用14天。</p>	
            <a-space>
                <a-button id="button" type="primary" @click="openHref('flutter bible hap', flutter_bibleHapUrl)">测试版v{{flutter_bibleHapVersion}} 下载</a-button>
                <a-button id="button" type="primary" @click="openHref('flutter bible hap tool', flutter_hapToolUrl)">侧载工具</a-button>
            </a-space>	
        </div>
        <div class='divider'></div>
        <div class="os">
            <h2><span class="icon iconfont">&#xe685;&#xe682;</span>iPhone、iPad</h2>
            <p v-if="false">请仔细看下面两种方式的操作流程。<span style='color: red'>推荐使用方式一</span>，通过Appstore下载安全稳定。方式二虽然安装方便，但可能存在掉签风险，掉签后无法安装，已安装的也会无法使用。</p>
            <p><span style='color: darkslateblue'>方式一：因未在中国大陆AppStore上线，可以通过<a href="https://appleid.apple.com" role="button">更改账号地区到港澳台</a>后，打开AppStore，退出账号重新登录后下载。对于更新，如不成功，请先删除之前下载的版本。</span></p>
            <p><span style='color: green'>方式二：使用轻松签、全能签或者易签助手的可以添加源地址（http://christapps.org/appstore）直接下载安装。 （ios14-15的一些设备可能可以免费使用轻松签，其他的需要购买证书。淘宝或拼多多搜 <span style='color: red'>p12签名</span>有35元质保300多天的，只能用于ipad的会便宜一点，注意甄别。一个签名只能用于一台设备。）。</span></p>					
            <p><span style='color: green'>方式三：可以通过电脑使用爱思助手签名的，可以下载安装包，重新签名后使用。爱思助手支持使用自己的苹果账号免费签名，有效7天，过期再重签。</span></p>					
            <a-space>
                <a-button id="button" type="primary" @click="openHref('html', 'appleid.htm')">换区流程</a-button>
                <a-button id="button" type="primary" @click="openHref('html', 'https://appleid.apple.com')">更换地区</a-button>
                <a-button id="button" type="primary" @click="openHref('flutter bible ipa', flutter_bibleIpaUrl)" v-if="flutter_bibleIpaUrl!=''">v{{flutter_bibleIpaVersion}} 下载（不会签名的不要下载）</a-button>
                <!-- <a-button id="button" type="primary" @click="openHref('bible ipa', bibleIpaUrl)" v-if="bibleIpaUrl!=''">v{{bibleIpaVersion}} 下载（不会签名的不要下载）</a-button>	 -->
            </a-space>
        </div>	
        <div class='divider'></div>
        <div class="os">
            <h2><span class="icon iconfont">&#xe684;</span>Windows电脑</h2>
            <p class="info">WPF版本从Win7开始支持;UWP版本，测试版本从Win10开始支持，测试版不支持32位系统。</p>					
            <span style='color: darkorange'>Win10系统使用Edge浏览器下载可能遇到的问题，</span><a href="qa.htm" role="button">点这里查看。</a><br>
            <span style='color: darkgoldenrod'>win10系统1803版本（18年3月）开始可以下载UWP版本，两个版本不冲突可以同时安装，哪个好用用哪个。安装前需要在设置里打开“开发人员模式”，同时安装证书，</span><a href="qa2.htm" role="button">点这里可以查看图文说明。</a><br>
            <a-space>
                <a-button id="button" type="primary" @click="openHref('flutter bible exe', flutter_bibleExeUrl)">测试版v{{flutter_bibleExeVersion}} 下载</a-button>
                <a-button id="button" type="primary" @click="openHref('bible exe', bibleExeUrl)">WPF v{{bibleExeVersion}} 下载</a-button>	
                <a-button id="button" type="primary" @click="openHref('bible appx', bibleAppxUrl)">UWP v{{bibleAppxVersion}} 下载</a-button>	
            </a-space>
        </div>
        <div class='divider'></div>
        <div class="os">
            <h2><span class="icon iconfont">&#xe67f;</span>苹果电脑</h2>
            <p class="info">10.15版本开始支持。</p>		
            <a-space>
                <a-button id="button" type="primary" @click="openHref('flutter bible mac', flutter_bibleDmgUrl)">测试版v{{flutter_bibleDmgVersion}} 下载</a-button>
                <a-button id="button" type="primary" @click="openHref('bible mac', bibleDmgUrl)">v{{bibleDmgVersion}} 下载</a-button>
            </a-space>
        </div>
    </div>   
</template>

<script>
export default {
    name: 'BibleView',
    props: {

    },
    data() {
        return {
            showWechat: false,
            bibleApkVersion: '3.6.1',
            bibleApkUrl: '/app/bible.apk',
            bibleExeVersion: '3.6.1',
            bibleExeUrl: '/app/bible.exe',
            bibleAppxVersion: '3.6.1',
            bibleAppxUrl: '/app/bible.appxbundle',
            bibleDmgVersion: '3.6.1',
            bibleDmgUrl: '/app/bible.dmg',
            bibleIpaVersion: '4.7',
            bibleIpaUrl: '/app/bible.ipa',
            flutter_bibleApkVersion: '0.4',
            flutter_bibleApkUrl: '/app/flutter_hymn.apk',
            flutter_bibleHapVersion: '0.4',
            flutter_bibleHapUrl: '/app/hymn.hap',
            flutter_hapToolUrl: '',
            flutter_bibleExeVersion: '0.4',
            flutter_bibleExeUrl: '/app/flutter_hymn.exe',
            flutter_bibleLinuxVersion: '0.4',
            flutter_bibleLinuxUrl: '/app/flutter_hymn.zip',
            flutter_bibleDmgVersion: '0.4',
            flutter_bibleDmgUrl: '/app/flutter_hymn.dmg',
            flutter_bibleIpaVersion: '0.4',
            flutter_bibleIpaUrl: '/app/flutter_hymn.ipa',
        };
    },
    computed: {

    },
    setup() {
        
    },
    created() {
        if (this.global.is_weixin()) {
            this.showWechat = true
        }
        var text = this.global.loadFile('url.json')
        console.log(text)
        var json = JSON.parse(text)
        if (json == null) return
        this.bibleApkVersion = json["bible"]["apkVersion"]
        this.bibleApkUrl = json["bible"]["apkUrl"]
        this.bibleExeVersion = json["bible"]["exeVersion"]
        this.bibleExeUrl = json["bible"]["exeUrl"]
        this.bibleAppxVersion = json["bible"]["appxVersion"]
        this.bibleAppxUrl = json["bible"]["appxUrl"]
        this.bibleDmgVersion = json["bible"]["dmgVersion"]
        this.bibleDmgUrl = json["bible"]["dmgUrl"]
        this.bibleIpaVersion = json["bible"]["ipaVersion"]
        this.bibleIpaUrl = json["bible"]["ipaUrl"]

        this.flutter_bibleApkVersion = json["bible"]["flutter_apkVersion"]
        this.flutter_bibleApkUrl = json["bible"]["flutter_apkUrl"]
        this.flutter_bibleHapVersion = json["bible"]["flutter_hapVersion"]
        this.flutter_bibleHapUrl = json["bible"]["flutter_hapUrl"]
        this.flutter_hapToolUrl = json["bible"]["flutter_hapToolUrl"]
        this.flutter_bibleExeVersion = json["bible"]["flutter_exeVersion"]
        this.flutter_bibleExeUrl = json["bible"]["flutter_exeUrl"]
        this.flutter_bibleLinuxVersion = json["bible"]["flutter_linuxVersion"]
        this.flutter_bibleLinuxUrl = json["bible"]["flutter_linuxUrl"]
        this.flutter_bibleDmgVersion = json["bible"]["flutter_dmgVersion"]
        this.flutter_bibleDmgUrl = json["bible"]["flutter_dmgUrl"]
        this.flutter_bibleIpaVersion = json["bible"]["flutter_ipaVersion"]
        this.flutter_bibleIpaUrl = json["bible"]["flutter_ipaUrl"]
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        openHref (category, url) {
            window.location.href = url
            this.$gtag.event('button', { 'event_category': category, 'event_label': url })
            this.$ba.trackEvent(category, 'button', url, '')
        },
    },
    components: {

    },
};
</script>

<style scoped>

.content {
    display:inline-block;
    text-align: left;
    max-width: 800px;
}
.wechat {
    position:relative;
    padding-top:20px;
    padding-bottom: 10px;
    color: black;
    background-color: #ebe7e7;
    font-size: 22px;
    text-align: center;
}
.red {
    color: red;
}
.description {
    color: gray;
    padding: 10px;
    -webkit-overflow-scrolling:touch;
    background-color:#efeff4;
}
.info {
    color: gray;
}
.os {
    padding: 10px;
}
p {
    margin: 0px;
}
a-divider {
    height: 1px;
}
.divider {
    width: 100%;
    height: 1px;
    position: relative;
    background-color: #eeeeee;
}
</style>
